module.exports = __webpack_public_path__ + "static/media/pro-tip-caller-on-hold.5b392057.png";